import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "GRID-NOTES-COMPONENT" }
const _hoisted_2 = { class: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "text-[12px] sm:text-[15px] font-bold text-left max-w-[90%]" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-700 absolute bottom-1 right-1"
}
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = {
  id: "CONTENT-DETAILS",
  class: "text-[10px] sm:text-[14px] text-left min-h-[50px] md:min-h-[100px]"
}
const _hoisted_8 = {
  key: 0,
  class: "text-blue-600 cursor-pointer font-semibold"
}
const _hoisted_9 = {
  key: 0,
  class: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1 mt-1 opacity-40"
}


import { Card as ACard } from "ant-design-vue";
import { PushpinOutlined as AIcon } from "@ant-design/icons-vue";
import { INote } from "@/models/INote";
import {
  getRelativeTime,
  PAGE_SIZE_DEFAULT,
  truncateText,
} from "@/utils/global";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'GridNotesComponent',
  props: {
  notes: {
    type: Array as () => Array<INote>,
    required: false,
  },
  loading: {
    type: Boolean,
  },
},
  setup(__props) {

const router = useRouter();

const PAGE_SIZE =
  window.innerWidth <= 640 ? PAGE_SIZE_DEFAULT - 2 : PAGE_SIZE_DEFAULT + 2;

const colors = [
  "bg-red-400",
  "bg-green-400",
  "bg-blue-400",
  "bg-yellow-400",
  "bg-indigo-400",
  "bg-purple-400",
  "bg-pink-400",
  "bg-teal-400",
  "bg-cyan-400",
];

const getRandomColor = (index: number) => {
  return colors[index % colors.length];
};

const handleCardClick = (slug: string) => {
  router.push({
    name: "NoteDetailPage",
    params: { slug },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.notes, (note) => {
        return (_openBlock(), _createBlock(_unref(ACard), {
          hoverable: true,
          key: note.id,
          class: _normalizeClass([
          'p-1 rounded-sm shadow-sm relative bg-opacity-30 cursor-pointer',
          getRandomColor(note.id),
        ]),
          onClick: ($event: any) => (handleCardClick(note.slug))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(note.title.toLocaleUpperCase()), 1),
              _createVNode(_unref(AIcon), {
                type: "pushpin",
                class: "text-[10px] sm:text-[20px] flex items-start absolute top-1 right-1 text-gray-700"
              }),
              (note?.updated_at)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getRelativeTime)(note?.updated_at)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_unref(truncateText)(note.detail, 50)) + " ", 1),
              (note.detail.length > 50)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " ...xem thêm "))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      }), 128))
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PAGE_SIZE), (i) => {
            return (_openBlock(), _createBlock(_unref(ACard), {
              loading: __props.loading,
              hoverable: false,
              key: i,
              class: "p-1 rounded-sm shadow-sm"
            }, null, 8, ["loading"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})